import { z } from 'zod';
import { JobSchema } from './Job';
import { WorstCaseSimulationResultSchema } from './WorstCaseSimulation';

export const WireSizingSchema = JobSchema.extend({
    result: WorstCaseSimulationResultSchema,
    errors: z
        .object({
            message: z.string(),
            connections: z.array(z.string()),
        })
        .array()
        .default([]),
});
